import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLAnchorElement> {
  static values = {
    timeout: { type: Number, default: 3000 },
  }

  declare readonly timeoutValue: number

  private requestPending = false
  private timeoutId: number | null = null

  click(): void {
    if (this.requestPending) return

    this.requestPending = true
    this.disable()
    this.timeoutId = window.setTimeout(() => this.reset(), this.timeoutValue)
  }

  handleResponse(): void {
    if (!this.requestPending) return

    this.reset()
  }

  disconnect(): void {
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
  }

  private disable(): void {
    this.element.classList.add("opacity-50", "pointer-events-none")
  }

  private reset(): void {
    this.requestPending = false
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
    this.element.classList.remove("opacity-50", "pointer-events-none")
  }
}
